import {useMutation} from '@tanstack/react-query';
import {removeAuthTokens} from 'infra/http/utils/auth-cookies';
import {clearCongenereEligibilityStorage} from 'infra/http/utils/clear-congenere-eligibility-storage';
import {clearLocalStorageFeatureFlags} from 'infra/http/utils/clear-local-storage-feature-flags';
import {queryClient} from 'infra/libs/react-query';
import {MUTATION_KEYS} from 'infra/libs/react-query/mutationKeys';
import {SignInEnum} from 'presentation/constants';
import {useFacialBiometricsStore} from 'presentation/modules/booking/shared/store/useFacialBiometricsStore';
import {getSidebar} from 'presentation/services/getSidebar';
import {useNavigate} from 'react-router-dom';

export const useGetSidebarMutation = () => {
	const navigate = useNavigate();
	const resetFacialBiometrics = useFacialBiometricsStore(state => state.resetFacialBiometrics);

	return useMutation({
		mutationKey: [MUTATION_KEYS.SIDEBAR],
		mutationFn: getSidebar,
		retry: 2,
		onError: () => {
			removeAuthTokens();
			navigate(SignInEnum.SIGN_IN, {state: {goToSignInState: true}});
			queryClient.clear();
			clearCongenereEligibilityStorage();
			clearLocalStorageFeatureFlags();
			resetFacialBiometrics();
		},
	});
};
